import React, { useState, useEffect, useRef } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import SelectGroups from 'react-select';
import SelectDivision from 'react-select';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { useForm } from "react-hook-form";
import { IconEyeOff, IconEye } from '@tabler/icons-react';
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const EditUserComp = (props) => {
  // console.log(props.user.password);

  const typingTimeout = useRef(null);
  const {
    setValue,
    trigger,
  } = useForm();

  const validatePassword = (value) => {
    const errors = [];
    if (!/.{8,}/.test(value)) errors.push("Minimal 8 karakter");
    if (!/[A-Z]/.test(value)) errors.push("Harus ada huruf kapital");
    if (!/[a-z]/.test(value)) errors.push("Harus ada huruf kecil");
    if (!/[0-9]/.test(value)) errors.push("Harus ada angka");
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) errors.push('Harus ada karakter khusus');


    return errors.length === 0 ? true : errors;
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setpassword(value);
    setValue("password", value);

    // Hentikan debounce sebelumnya jika ada
    if (typingTimeout.current) clearTimeout(typingTimeout.current);

    // Set debounce baru untuk validasi setelah 1 detik
    typingTimeout.current = setTimeout(() => {
      // ⛔ Jangan validasi jika field kosong
      if (!value) return;

      const validationResult = validatePassword(value);
      if (validationResult !== true) {
        setDisabled(true)
        MySwal.fire({
          icon: 'error',
          title: 'Oops, Error!',
          html: `<ul style="text-align:left">${validationResult.map(err => `<li>${err}</li>`).join('')}</ul>`,
        });
      } else {
        setDisabled(false)
        trigger("password"); // trigger validasi form jika password valid
      }
    }, 1000);
  };

  const [showPassword, setShowPassword] = useState(false);

  const [disabledDivision, setDisabledDivision] = useState(
    props?.user?.mapping_user_groups[0]?.group?.id === "34373ecb-00d0-4e0b-b1f7-f1095993dc49" ? true : false
  );
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [fullname, setfullname] = useState(props.user.namaLengkap);
  const [username, setusername] = useState(props.user.username);
  const [active, setactive] = useState(props.user.active);
  const [password, setpassword] = useState('');
  const [nik, setnik] = useState(props.user.nik);
  const [email, setemail] = useState(props.user.email);
  const [idGroup, setidGroup] = useState({
    value: props?.user?.mapping_user_groups[0]?.group?.id,
    label: props?.user?.mapping_user_groups[0]?.group?.namaGroup,
  });
  const [groups, setgroups] = useState([]);
  const [idDivision, setidDivision] = useState({
    value: props?.user?.risk_division?.id,
    label: props?.user?.risk_division?.namaDivision,
  });
  const [divisions, setdivisions] = useState([]);
  const [jabatan, setjabatan] = useState(props.user.jabatan);

  const fetchGroups = async () => {
    try {
      const options = {
        url: `/groups/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setgroups([]);
      data.map((d) =>
        setgroups((group) => [
          ...group,
          {
            label: d.namaGroup,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/users/edit.fetchGroups');
    }
  };

  const fetchDivisions = async () => {
    try {
      const options = {
        url: `/risk-divisions/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setdivisions([]);
      data.map((d) =>
        setdivisions((divisions) => [
          ...divisions,
          {
            label: d.namaDivision,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/users/edit.fetchDivisions');
    }
  };

  useEffect(() => {
    fetchGroups();
    fetchDivisions();
  }, []);

  const handleUpdate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      active: active,
      username: username,
      nik: parseInt(nik) || null,
      email: email,
      namaLengkap: fullname,
      password: password,
      idGroups: idGroup?.value,
      idDivision: idDivision?.value,
      jabatan: jabatan,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: `/users/update/${props?.user?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully updated User!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  const handleChangeGroup = (object) => {
    // if surveyor external
    setidGroup(object)
    if (object?.value === "34373ecb-00d0-4e0b-b1f7-f1095993dc49") {
      setDisabledDivision(true)
      setidDivision({
        label: "Pihak External",
        value: "ad80872a-d0fc-47fa-9df8-ab4d5d55826f"
      })
      setjabatan("Surveior External")
    } else {
      setDisabledDivision(false)
      setidDivision({
        label: props?.user?.risk_division?.namaDivision,
        value: props?.user?.risk_division?.id
      })
      setjabatan(props?.user?.jabatan)
    }
  }

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="fullname" className="col-sm-2 col-form-label required">
          Nama
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="fullname"
            onChange={(e) => setfullname(e.target.value)}
            value={fullname || ''}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="nik" className="col-sm-2 col-form-label required">
          NIK
        </label>
        <div className="col-sm-10">
          <input
            type="number"
            className="form-control"
            id="nik"
            onChange={(e) => setnik(e.target.value)}
            value={nik || ''}
          />
          <small className='text-info'>Tidak wajib di isi untuk Group Surveior External</small>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="email" className="col-sm-2 col-form-label required">
          Email
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            id="email"
            onChange={(e) => setemail(e.target.value)}
            value={email || ''}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="username" className="col-sm-2 col-form-label required">
          Username
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="username"
            onChange={(e) => setusername(e.target.value)}
            value={username || ''}
          />
        </div>
      </div>
      {/* <div className="mb-3 row">
        <label htmlFor="password" className="col-sm-2 col-form-label">
          Password
        </label>
        <div className="col-sm-10">
          <input
            type="password"
            className="form-control"
            id="password"
            onChange={(e) => setpassword(e.target.value)}
            value={password || ''}
          />
          <small className='text-info'>Jika tidak ada perubahan cukup dikosongkan.</small>
        </div>
      </div> */}
      <div className="mb-3 row">
        <div className='d-flex'>
          <label htmlFor="password" className="col-sm-2 col-form-label">
            Password
          </label>

          <div className="col-9">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control pe-5" // ruang tambahan agar tombol tidak menimpa teks
              id="password"
              value={password}
              onChange={handlePasswordChange}
            />
            <small className='text-info'>Jika tidak ada perubahan cukup dikosongkan.</small>
          </div>
          <div className="col-1">
            {/* Tombol tampilkan/sembunyikan password */}
            {
              password.length > 0 ?
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="btn btn-link top-50"
                  style={{ textDecoration: 'none', marginLeft: '10%' }}
                >
                  {showPassword ? <IconEyeOff /> : <IconEye />}
                </button>
                :
                ''
            }
          </div>
        </div>

      </div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-2 col-form-label required">
          Group
        </label>
        <div className="col-sm-10">
          <SelectGroups
            id="group"
            value={idGroup || ''}
            onChange={handleChangeGroup}
            options={groups}
            placeholder="Cari groups"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label
          htmlFor="namaDivision"
          className="col-sm-2 col-form-label required"
        >
          Division
        </label>
        <div className="col-sm-10">
          <SelectDivision
            id="namaDivisions"
            value={idDivision || ''}
            onChange={setidDivision}
            options={divisions}
            placeholder="Cari division"
            isDisabled={disabledDivision}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="jabatan" className="col-sm-2 col-form-label required">
          Jabatan
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="jabatan"
            onChange={(e) => setjabatan(e.target.value)}
            value={jabatan || ''}
            disabled={disabledDivision}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="active" className="col-sm-2 col-form-label">
          Active
        </label>
        <div className="col-sm-10">
          <select
            className="form-control"
            onChange={(e) => setactive(e.target.value)}
            value={active || ''}
          >
            <option value="">- Pilih -</option>
            <option value="YES">Yes</option>
            <option value="NO">No</option>
          </select>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleUpdate()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditUserComp;
